import StorageKeys from 'src/lib/storage/storageKeys';
import usePersistedState from 'src/hooks/globalState/usePersistedState';
export default function useConfigStorage() {
    return usePersistedState(StorageKeys.configService);
}
